function BuildElementIcon(elementType: ElementType): HTMLElement {
    const icon = document.createElement('span');
    icon.className = "element-icon";
    icon.dataset.element = elementType;
    return icon;
}
